import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LoadingSpinner } from '@/components';
import { useIsAdmin } from '@/hooks/useAuth';
import { useSpaceAccess } from '@/contexts/SpaceAccessContext';
import ConfigLayout from './config';

const ApiTokens = lazy(() => import('./config/ApiTokens'));
const WebhookSettings = lazy(() => import('./config/WebhookSettings'));
const AlertSettings = lazy(() => import('./config/AlertSettings'));

export const ConnectPage = () => {
  const isAdmin = useIsAdmin();
  const { isLoading } = useSpaceAccess();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="bg-surface-sunken w-full">
      <Routes>
        <Route path="/connect/config" element={<ConfigLayout />}>
          <Route
            path="api-tokens"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <ApiTokens />
              </Suspense>
            }
          />
          <Route
            path="webhooks"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <WebhookSettings />
              </Suspense>
            }
          />
          <Route
            path="alerts"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <AlertSettings />
              </Suspense>
            }
          />
          <Route index element={<Navigate to="api-tokens" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/connect/config/api-tokens" replace />} />
      </Routes>
    </div>
  );
};

export default ConnectPage;
